<template>
  <div class="pa-0 ma-0">
    <label style="color:grey;">{{ fieldLabel }}</label>
    <v-select
      :items="options"
      item-text="label"
      item-value="label"
      v-model="extraFieldsValue.value"
      dense
    />
  </div>
</template>
<script>
export default {
  name: 'Dropdown',
  props: {
    isrequired: {
      type: Boolean,
      default: false
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    extraFieldsValue: {
      type: Object,
      default: () => { return {} }
    },
    options: {
      type: Array,
      default: () => { return {} }
    }
  },
  data () {
    return {
    }
  },

  methods: {

  }
}
</script>
